export interface PageTitleProps {
  children: string;
}

/* Exactly one per page. In-page detail titles are h2s, never a second h1. */
export function PageTitle({ children }: PageTitleProps) {
  return <h1 className='text-display text-ink'>{children}</h1>;
}
